import { render, staticRenderFns } from "./ReLeadServices.vue?vue&type=template&id=35018f5a&scoped=true"
import script from "./ReLeadServices.vue?vue&type=script&lang=js"
export * from "./ReLeadServices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35018f5a",
  null
  
)

export default component.exports